import { render, staticRenderFns } from "./listadoCategory.vue?vue&type=template&id=2b665904"
import script from "./listadoCategory.vue?vue&type=script&lang=js"
export * from "./listadoCategory.vue?vue&type=script&lang=js"
import style0 from "./listadoCategory.vue?vue&type=style&index=0&id=2b665904&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports